import './BreadCrumbs.scss';
import Component from './BreadCrumbs.js';
export default Component;
